import { AnalyticsEventParams, AnalyticsEvents } from './analytics.events';

export const configAnalytics = (): void => {
  gtag('js', new Date());
  gtag('config', window.config.GA_MEASUREMENT_ID, {
    send_page_view: false,
  });
};

export const trackEvent = <T extends AnalyticsEvents>(name: T, params?: AnalyticsEventParams[T]): void => {
  try {
    gtag('event', name, params);
  } catch (error) {
    console.error(error);
  }
};

export const trackPageView = (pageName: string): void => {
  trackEvent(AnalyticsEvents.PageView, {
    page_title: pageName,
  });
};

export const setUserId = (userId: string): void => {
  gtag('set', {
    user_id: userId,
  });
};
